var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromisesBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 986,
    height: 222,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M765.435 220.999C765.435 99.6902 667.132 1.34953 545.87 1.34951C424.608 1.34948 325.981 99.6901 325.981 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M774.166 220.999C774.166 109.395 675.863 18.8182 554.601 18.8182C433.339 18.8182 335.036 109.395 335.036 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M782.899 220.999C782.899 119.1 684.596 36.2866 563.334 36.2866C442.072 36.2866 343.445 119.1 343.445 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M791.629 220.997C791.629 128.803 693.326 54.0769 572.064 54.0769C450.802 54.0769 352.499 128.803 352.499 220.997",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M800.682 220.999C800.682 138.509 702.379 71.5468 581.117 71.5468C459.855 71.5467 361.229 138.509 361.229 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M809.414 220.999C809.414 148.214 711.111 89.0155 589.849 89.0154C468.587 89.0154 369.961 148.214 369.961 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M818.146 220.997C818.146 157.916 719.843 106.805 598.581 106.805C477.319 106.805 378.692 157.916 378.692 220.997",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M826.876 220.999C826.876 167.623 728.573 124.276 607.311 124.276C486.049 124.276 387.423 167.623 387.423 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M835.604 220.998C835.604 177.327 737.301 141.744 616.04 141.744C494.778 141.744 396.475 177.327 396.475 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M844.336 220.998C844.336 187.032 746.033 159.536 624.771 159.536C503.509 159.536 405.206 187.032 405.206 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M853.391 220.999C853.391 196.738 755.088 177.005 633.826 177.005C512.564 177.005 413.938 196.737 413.938 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M862.121 220.998C862.121 206.441 763.818 194.472 642.556 194.472C521.294 194.472 422.668 206.441 422.668 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M545.546 220.998C545.546 99.6899 643.849 1.34924 765.111 1.34926C886.373 1.34928 984.999 99.69 984.999 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M536.815 220.998C536.815 109.395 635.119 18.8178 756.38 18.8178C877.642 18.8178 975.945 109.395 975.945 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M528.085 220.998C528.085 119.099 626.388 36.2854 747.65 36.2854C868.912 36.2854 967.538 119.099 967.538 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M519.353 220.999C519.353 128.805 617.656 54.0786 738.917 54.0786C860.179 54.0786 958.806 128.805 958.806 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M510.626 220.999C510.626 138.509 608.929 71.5467 730.191 71.5468C851.453 71.5468 950.079 138.509 950.079 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M501.896 220.996C501.896 148.211 600.199 89.013 721.46 89.013C842.722 89.013 941.025 148.212 941.025 220.997",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M492.838 220.998C492.838 157.918 591.141 106.807 712.403 106.807C833.665 106.807 932.291 157.918 932.291 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M484.108 220.998C484.108 167.623 582.411 124.275 703.673 124.275C824.935 124.275 923.562 167.623 923.562 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M475.377 220.998C475.377 177.327 573.68 141.743 694.942 141.743C816.204 141.743 914.507 177.327 914.507 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M466.646 220.998C466.646 187.032 564.95 159.535 686.211 159.535C807.473 159.535 905.776 187.032 905.776 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M457.915 220.999C457.915 196.738 556.218 177.005 677.48 177.005C798.742 177.005 897.368 196.738 897.368 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M449.185 220.998C449.185 206.441 547.488 194.472 668.749 194.472C790.011 194.472 888.314 206.441 888.314 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M440.129 220.998C440.129 216.146 538.432 212.264 659.694 212.264C780.956 212.264 879.582 216.146 879.582 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M870.852 220.998C870.852 216.146 772.549 212.264 651.287 212.264C567.535 212.264 494.778 214.205 457.591 216.792",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.418 220.999C106.418 99.6904 204.721 1.34972 325.983 1.34973C447.245 1.34974 545.548 99.6904 545.548 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3633 220.999C97.3633 109.395 195.99 18.8183 317.252 18.8183C438.514 18.8183 536.817 109.395 536.817 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6328 220.998C88.6328 119.099 186.936 36.2861 308.198 36.2861C429.46 36.2861 528.086 119.099 528.086 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9023 220.999C79.9024 128.805 178.205 54.0788 299.467 54.0788C420.729 54.0788 519.356 128.805 519.356 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1729 220.999C71.1729 138.51 169.476 71.5473 290.738 71.5474C412 71.5474 510.626 138.51 510.626 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4424 220.997C62.4424 148.212 160.745 89.0134 282.007 89.0135C403.269 89.0135 501.896 148.212 501.896 220.997",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7109 221C53.7109 157.919 152.014 106.808 273.276 106.808C394.538 106.808 492.841 157.919 492.841 221",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6553 220.999C44.6553 167.623 142.958 124.276 264.22 124.276C385.482 124.276 484.109 167.623 484.109 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9229 220.998C35.9229 177.327 134.226 141.743 255.811 141.744C377.396 141.744 475.376 177.327 475.376 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1953 220.999C27.1953 187.033 125.498 159.536 246.76 159.536C368.022 159.536 466.325 187.033 466.325 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4619 221C18.4619 196.738 116.765 177.005 238.027 177.005C359.289 177.005 457.915 196.738 457.915 221",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73145 220.999C9.73145 206.442 108.034 194.473 229.296 194.473C350.558 194.473 449.185 206.442 449.185 220.999",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1 220.998C1 216.145 99.303 212.263 220.565 212.263C341.827 212.264 440.13 216.145 440.13 220.998",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M431.398 220.998C431.398 216.145 333.095 212.263 211.833 212.263C128.082 212.263 55.3247 214.204 18.1377 216.792",
    stroke: "#5048DB",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromisesBackground);
export default __webpack_public_path__ + "static/media/promises-background.5a433e9f1305dd4e2ed08825b711f8df.svg";
export { ForwardRef as ReactComponent };